/**
 *  @class
 *  @function PredictiveSearch
 *  Supports both old overlay search and new inline search (header-style4)
 */
class PredictiveSearch {
  constructor() {
    // Try new inline search first (header-style4)
    this.inlineSearch = document.querySelector('.header-search-area');
    
    // Fallback to old overlay search
    this.container = document.querySelector('.thb-quick-search');
    
    if (this.inlineSearch && this.inlineSearch.querySelector('.header-predictive-results')) {
      this.setupInlineSearch();
    } else if (this.container) {
      this.setupOverlaySearch();
    }
  }

  // New inline search setup (header-style4)
  setupInlineSearch() {
    this.input = this.inlineSearch.querySelector('input[type="search"]');
    this.form = this.inlineSearch.querySelector('form');
    this.predictiveSearchResults = this.inlineSearch.querySelector('.header-predictive-results');
    
    if (!this.input || !this.predictiveSearchResults) {
      console.warn('Predictive search: Missing input or results container');
      return;
    }

    // Form submit
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    // Input change with debounce
    let debounceTimer;
    this.input.addEventListener('input', (event) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.onChange(event);
      }, 300);
    });

    // Focus event - show results if there's a query
    this.input.addEventListener('focus', () => {
      const searchTerm = this.getQuery();
      if (searchTerm.length >= 2) {
        this.getSearchResults(searchTerm);
      }
    });

    // Close on click outside
    document.addEventListener('click', (event) => {
      if (!this.inlineSearch.contains(event.target)) {
        this.predictiveSearchResults.classList.remove('active');
      }
    });

    // Close on escape
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.predictiveSearchResults.classList.remove('active');
        this.input.blur();
      }
    });
  }

  // Old overlay search setup (legacy)
  setupOverlaySearch() {
    this.button = document.getElementById('quick-search');
    this.close_button = this.container.querySelector('.thb-search-close');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');

    if (!this.input) return;

    const form = this.container.querySelector('form.searchform');
    if (form) {
      form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    let debounceTimer;
    this.input.addEventListener('input', (event) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.onChange(event);
      }, 300);
    });

    if (this.button) {
      this.button.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        const headerSection = document.querySelector('.header-section');
        if (headerSection) {
          headerSection.classList.toggle('search-open');

          if (headerSection.classList.contains('search-open')) {
            setTimeout(function () {
              _this.input.focus({
                preventScroll: true
              });
            }, 100);
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('search:open');
            }
          }
        }
        return false;
      });
    }

    // Close
    if (this.close_button) {
      this.close_button.addEventListener('click', (event) => {
        this.close();
        event.preventDefault();
      });
    }
    
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  categoryToggle() {
    if (!this.predictiveSearchResults) return;
    
    this.category_toggle = this.predictiveSearchResults.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.predictiveSearchResults.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        const targetSection = this.predictiveSearchResults.querySelector(target);
        if (targetSection) {
          targetSection.classList.add('active');
        }
        event.preventDefault();
      });
    });
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length < 2) {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.remove('active');
        this.predictiveSearchResults.classList.remove('loading');
      }
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  getSearchResults(searchTerm) {
    if (!this.predictiveSearchResults) return;
    
    this.predictiveSearchResults.classList.add('loading');
    this.predictiveSearchResults.classList.add('active');

    // Check if theme.routes exists
    if (typeof theme === 'undefined' || !theme.routes || !theme.routes.predictive_search_url) {
      console.warn('Predictive search: theme.routes.predictive_search_url not defined');
      this.predictiveSearchResults.classList.remove('loading');
      return;
    }

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const resultsSection = doc.querySelector('#shopify-section-predictive-search');
        
        if (resultsSection) {
          this.renderSearchResults(resultsSection.innerHTML);
        } else {
          this.predictiveSearchResults.innerHTML = '<div style="padding: 20px; text-align: center; color: #666;">No results found</div>';
          this.predictiveSearchResults.classList.add('active');
        }
      })
      .catch((error) => {
        console.error('Predictive search error:', error);
        this.predictiveSearchResults.classList.remove('loading');
        this.predictiveSearchResults.classList.remove('active');
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchResults) return;
    
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.predictiveSearchResults.classList.add('active');
    this.categoryToggle();
  }

  open() {
    const headerSection = document.querySelector('.header-section');
    if (headerSection) {
      headerSection.classList.add('search-open');
    }
  }

  close() {
    const headerSection = document.querySelector('.header-section');
    if (headerSection) {
      headerSection.classList.remove('search-open');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PredictiveSearch();
  });
} else {
  new PredictiveSearch();
}
